import { render, staticRenderFns } from "./companylist.vue?vue&type=template&id=55384668&"
import script from "./companylist.vue?vue&type=script&lang=js&"
export * from "./companylist.vue?vue&type=script&lang=js&"
import style0 from "./companylist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports